import React, { useEffect, useState } from "react"
import Input from "../../Input"
import { toast } from "react-toastify"

const VoiceStatusChange = ({ values, serverData }) => {
    const [adminPokeFormats, setAdminPokeFormats] = useState([])
    const [clientPokeFormats, setClientPokeFormats] = useState([])
    const [openedAdminPokeFormat, setOpenedAdminPokeFormat] = useState(null)
    const [openedClientPokeFormat, setOpenedClientPokeFormat] = useState(null)

    const handleAdd = (forClient) => {
        const time = document.getElementById(`${forClient ? "clientPokeFormat" : "adminPokeFormat"}-time`).value
        const pokeFormat = document.getElementById(
            `${forClient ? "clientPokeFormat" : "adminPokeFormat"}-pokeFormat`,
        ).value

        if (forClient) {
            setOpenedClientPokeFormat(null)
            setClientPokeFormats((oldV) => {
                return [...oldV, { time, pokeFormat }]
            })
        } else {
            setOpenedAdminPokeFormat(null)
            setAdminPokeFormats((oldV) => {
                return [...oldV, { time, pokeFormat }]
            })
        }
    }

    const handleEdit = (forClient) => {
        const time = document.getElementById(`${forClient ? "clientPokeFormat" : "adminPokeFormat"}-time`).value
        const pokeFormat = document.getElementById(
            `${forClient ? "clientPokeFormat" : "adminPokeFormat"}-pokeFormat`,
        ).value

        if (forClient) {
            setClientPokeFormats((oldV) => {
                return oldV.map((r) => {
                    if (r.time != openedClientPokeFormat.time) {
                        return r
                    } else {
                        return { time, pokeFormat }
                    }
                })
            })
            setOpenedClientPokeFormat(null)
        } else {
            setAdminPokeFormats((oldV) => {
                return oldV.map((r) => {
                    if (r.time != openedAdminPokeFormat.time) {
                        return r
                    } else {
                        return { time, pokeFormat }
                    }
                })
            })
            setOpenedAdminPokeFormat(null)
        }
    }

    const handleDelete = (forClient) => {
        if (forClient) {
            setClientPokeFormats((oldV) => {
                return oldV.filter((r) => r.time != openedClientPokeFormat.time)
            })
            setOpenedClientPokeFormat(null)
        } else {
            setAdminPokeFormats((oldV) => {
                return oldV.filter((r) => r.time != openedAdminPokeFormat.time)
            })
            setOpenedAdminPokeFormat(null)
        }
    }

    useEffect(() => {
        let adminPokeFormatsInput = document.getElementsByName(`voiceStatusChange-adminPokeFormats`)[0]
        adminPokeFormatsInput.value = JSON.stringify(adminPokeFormats)
    }, [adminPokeFormats])
    useEffect(() => {
        let clientPokeFormatsInput = document.getElementsByName(`voiceStatusChange-clientPokeFormats`)[0]
        clientPokeFormatsInput.value = JSON.stringify(clientPokeFormats)
    }, [clientPokeFormats])

    useEffect(() => {
        if (values?.adminPokeFormats) {
            try {
                const r = JSON.parse(values?.adminPokeFormats)
                setAdminPokeFormats(r)
            } catch (err) {
                setAdminPokeFormats(values.adminPokeFormats || [])
            }
        }
        if (values?.clientPokeFormats) {
            try {
                const r = JSON.parse(values?.clientPokeFormats)
                setClientPokeFormats(r)
            } catch (err) {
                setClientPokeFormats(values.clientPokeFormats || [])
            }
        }
    }, [values?.adminPokeFormats])

    return (
        <div className="mx-14 h-full font-sans">
            <input name={`voiceStatusChange-adminPokeFormats`} className="hidden" />
            <input name={`voiceStatusChange-clientPokeFormats`} className="hidden" />

            <h6 className="flex justify-center">اطلاعیه بستن میکروفون</h6>
            <div className="">
                <Input
                    type="text"
                    label="ایدی ادمین برای اطلاعیه *"
                    name={`voiceStatusChange-sgListToNotify`}
                    placeholder="RankID"
                    options={serverData?.sgList}
                    multi={true}
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.sgListToNotify}
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    label="ایدی رنک ها برای چشم پوشی"
                    name={`voiceStatusChange-ignoreSgList`}
                    placeholder="مثال: 1,2,3"
                    options={serverData?.sgList}
                    multi={true}
                    autoComplete="off"
                    defaultValue={values?.ignoreSgList}
                    dir="ltr"
                />
            </div>
            <p>فرمت های پوک برای ادمین</p>
            <div className="mt-2">
                <div className="flex">
                    {adminPokeFormats?.map((item, i) => (
                        <div key={i}>
                            <span
                                role="button"
                                className="text-blue-400"
                                onClick={() => {
                                    setOpenedAdminPokeFormat(item)
                                }}
                            >
                                {item.time}
                            </span>
                            {" , "}
                        </div>
                    ))}
                    <button
                        id="rankButton"
                        type="button"
                        className="px-2 bg-gray-700 rounded-md"
                        onClick={() => {
                            setOpenedAdminPokeFormat({ time: "", pokeFormat: "" })
                        }}
                    >
                        Add
                    </button>
                </div>
                <div>
                    {openedAdminPokeFormat && (
                        <div className="flex justify-between place-items-center gap-5">
                            <div className="flex gap-5">
                                <div>
                                    <Input
                                        type="number"
                                        name={`adminPokeFormat-time`}
                                        label="تایم به ثانیه"
                                        placeholder="time"
                                        autoComplete="off"
                                        dir="ltr"
                                        defaultValue={openedAdminPokeFormat.time}
                                    />
                                </div>
                                <div>
                                    <Input
                                        type="text"
                                        name={`adminPokeFormat-pokeFormat`}
                                        label="فرمت پوک"
                                        placeholder="PokeFormat"
                                        autoComplete="off"
                                        dir="ltr"
                                        defaultValue={openedAdminPokeFormat.pokeFormat}
                                    />
                                </div>
                            </div>

                            {openedAdminPokeFormat.time !== "" ? (
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        id="editButton"
                                        className="styled-button px-2 success justify-item-center mt-5 border-none"
                                        onClick={() => {
                                            handleEdit(false)
                                        }}
                                    >
                                        ویرایش
                                    </button>
                                    <button
                                        type="button"
                                        id="deleteButton"
                                        className="styled-button px-2 danger justify-item-center mt-5 border-none"
                                        onClick={() => handleDelete(false)}
                                    >
                                        حذف
                                    </button>
                                    <button
                                        type="button"
                                        className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                                        id="cancellButton"
                                        onClick={() => {
                                            setOpenedAdminPokeFormat(null)
                                        }}
                                    >
                                        بیخیال
                                    </button>
                                </div>
                            ) : (
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        id="addButton"
                                        className="styled-button px-2 success justify-item-center mt-5 border-none"
                                        onClick={() => handleAdd(false)}
                                    >
                                        اضافه
                                    </button>
                                    <button
                                        type="button"
                                        className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                                        id="cancellButton"
                                        onClick={() => {
                                            setOpenedAdminPokeFormat(null)
                                        }}
                                    >
                                        بیخیال
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <p>فرمت های پوک برای کلاینت</p>
            <div className="mt-2">
                <div className="flex">
                    {clientPokeFormats.map((item, i) => (
                        <div key={i}>
                            <span
                                role="button"
                                className="text-blue-400"
                                onClick={() => {
                                    setOpenedClientPokeFormat(item)
                                }}
                            >
                                {item.time},
                            </span>
                        </div>
                    ))}
                    <button
                        id="rankButton"
                        type="button"
                        className="px-2 bg-gray-700 rounded-md"
                        onClick={() => {
                            setOpenedClientPokeFormat({ time: "", pokeFormat: "" })
                        }}
                    >
                        Add
                    </button>
                </div>
                <div>
                    {openedClientPokeFormat && (
                        <div className="flex justify-between place-items-center gap-5">
                            <div className="flex gap-5">
                                <div>
                                    <Input
                                        type="number"
                                        name={`clientPokeFormat-time`}
                                        label="تایم به ثانیه"
                                        placeholder="time"
                                        autoComplete="off"
                                        dir="ltr"
                                        defaultValue={openedClientPokeFormat.time}
                                    />
                                </div>
                                <div>
                                    <Input
                                        type="text"
                                        name={`clientPokeFormat-pokeFormat`}
                                        label="فرمت پوک"
                                        placeholder="PokeFormat"
                                        autoComplete="off"
                                        dir="ltr"
                                        defaultValue={openedClientPokeFormat.pokeFormat}
                                    />
                                </div>
                            </div>

                            {openedClientPokeFormat.time !== "" ? (
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        id="editButton"
                                        className="styled-button px-2 success justify-item-center mt-5 border-none"
                                        onClick={() => {
                                            handleEdit(true)
                                        }}
                                    >
                                        ویرایش
                                    </button>
                                    <button
                                        type="button"
                                        id="deleteButton"
                                        className="styled-button px-2 danger justify-item-center mt-5 border-none"
                                        onClick={() => handleDelete(true)}
                                    >
                                        حذف
                                    </button>
                                    <button
                                        type="button"
                                        className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                                        id="cancellButton"
                                        onClick={() => {
                                            setOpenedClientPokeFormat(null)
                                        }}
                                    >
                                        بیخیال
                                    </button>
                                </div>
                            ) : (
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        id="addButton"
                                        className="styled-button px-2 success justify-item-center mt-5 border-none"
                                        onClick={() => handleAdd(true)}
                                    >
                                        اضافه
                                    </button>
                                    <button
                                        type="button"
                                        className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                                        id="cancellButton"
                                        onClick={() => {
                                            setOpenedClientPokeFormat(null)
                                        }}
                                    >
                                        بیخیال
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>زمانی که کاربری در سرور شما به در یک سرور دیگر ویسش را باز کند به شما اطلاع میدهد</span>
                <br />
                <span>متغیرها:</span>
                <div dir="ltr">
                    <div>%user: نام کاربر</div>
                    <div>%time: زمان به ثانیه</div>
                </div>
            </div>
        </div>
    )
}

export default VoiceStatusChange
